import { localDB } from "@/database/db";

import { clickSignupButtonDataLayer } from "@/lib/data-layer/utils";

import { SignUpButton, useUser } from "@clerk/react-router";
import { AvatarWithDropdown } from "../avatar-with-dropdown";
import { useLocation, useNavigate } from "react-router";
import { ComponentProps } from "react";
import { ConditionalWrapper } from "../utils/utils";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";
import { usePostHog } from "posthog-js/react";

export default function LoginButton({
  children,
  destinationWhenLoggedIn = "/add",
  showAvatarWhenLoggedIn = false,
  size = "md",
  variant = "primary",
  onClick,
  className,
}: {
  destinationWhenLoggedIn?: string;
  showAvatarWhenLoggedIn?: boolean;
  children: React.ReactNode;
  size?: ComponentProps<typeof Button>["size"];
  variant?: ComponentProps<typeof Button>["variant"];
  onClick?: () => void;
  className?: string;
}) {
  const authData = useUser();
  const navigateTo = useNavigate();
  const pathname = useLocation().pathname;
  const posthog = usePostHog();

  return !authData.isLoaded ? (
    <></>
  ) : !showAvatarWhenLoggedIn || !authData.isSignedIn ? (
    <ConditionalWrapper
      wrapper={(children) => {
        return (
          <SignUpButton
            mode="modal"
            forceRedirectUrl="/welcome"
            signInFallbackRedirectUrl="/welcome-back"
            signInForceRedirectUrl="/welcome-back"
            fallbackRedirectUrl="/welcome"
          >
            {children}
          </SignUpButton>
        );
      }}
      condition={!authData.isSignedIn}
    >
      <Button
        variant={variant}
        size={size}
        onClick={() => {
          onClick?.();
          posthog.capture("Homepage-Get-Started-Clicked", {
            pathname,
          });
          if (!authData.isSignedIn) {
            console.warn("clearall triggered");
            clickSignupButtonDataLayer();
            localDB.clearAll();
          } else {
            navigateTo(destinationWhenLoggedIn);
          }
        }}
        className={cn("white", className)}
      >
        {children}
      </Button>
    </ConditionalWrapper>
  ) : (
    <div className="flex items-center justify-center gap-1">
      <AvatarWithDropdown />
    </div>
  );
}
